import { ITeamCalendarResults, TeamCalendarResults } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { TeamCalendarAndResultsQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<TeamCalendarAndResultsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<TeamCalendarAndResultsQuery>): ITeamCalendarResults => {
  return transformer(props);
}

const TeamCalendarResultsWidget = ({
  props,
  ...rest
}: WidgetContext<ITeamCalendarResults>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <TeamCalendarResults {...props} />
    </div>
  );
}

export default TeamCalendarResultsWidget;